// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1I9iQ","signatureBlock":"Footer_signatureBlock__dlQ6Y","signature":"Footer_signature__38vKD"};